import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { Provider } from "react-redux";
import { appStore } from "./app/store";
import { Toaster } from "./components/ui/sonner";
import {useLoadUserQuery} from "./features/api/authApi";
import LoadingSpinner from "./components/ui/LoadingSpinner";
import { HelmetProvider } from "react-helmet-async";

const Custom = ({ children }) => {
  const { isLoading } = useLoadUserQuery();

  return isLoading ? <LoadingSpinner /> : children;
};

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={appStore}>
      <HelmetProvider>
        <Custom>
          <App />
          <Toaster />
        </Custom>
      </HelmetProvider>
    </Provider>
  </StrictMode>
);
